// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        cssOverrides: {
            children: css`
                padding: 0 ${pxToRem(20)};
                background-color: ${getColor("common.background")};
            `,
        },
        headerColor: "common.background",
        bodyColor: "common.background",
        childTypographyProps: {
            color: "primary",
            css: css`
                font-weight: ${({ theme }) => theme.design.typography.weight.base};
            `,
        },
        panelRowProps: {
            color: "common.background",
            moreIconProps: {
                css: css`
                    color: ${getColor("primary")};
                `,
            },
            css: css`
                width: 100%;
                padding: ${pxToRem(20)};
                border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};

                * {
                    color: ${getColor("primary")};
                }

                &:hover * {
                    color: ${getColor("secondary")};
                }

                &:focus,
                &:active {
                    background-color: ${getColor("common.accent")};
                    outline-offset: ${pxToRem(-2)};
                }
            `,
            // Theme doesn't work here. Needs to be investigated
            isCurrentCss: css`
                background-color: #f3f5f7; /* common.accent color */

                [class*="TypographyStyle"] {
                    font-weight: 700; /* theme.design.typography.weight.bold */
                }
            `,
        },
    },
};

export default panelMenu;
